import { postFormDataAPI } from "./Networking";
import { SwayyAPIResponse } from "../../../models/NetworkResponse";

const extractUrls = (payload: unknown): string[] => {
  if (!payload) return [];
  if (Array.isArray(payload)) {
    return payload.filter((item): item is string => typeof item === "string");
  }
  if (typeof payload === "object") {
    const record = payload as Record<string, unknown>;
    const candidates = [record.urls, record.images, record.image_urls];
    for (const candidate of candidates) {
      if (Array.isArray(candidate)) {
        return candidate.filter(
          (item): item is string => typeof item === "string",
        );
      }
    }
  }
  return [];
};

export default class SwayyImageAPI {
  uploadMultiple = async (
    files: File[],
    foldername: string,
  ): Promise<string[]> => {
    try {
      if (!files.length) {
        throw new Error("No files provided for upload.");
      }
      if (!foldername.trim()) {
        throw new Error("foldername is required for image upload.");
      }

      const formData = new FormData();
      files.forEach((file) => formData.append("files", file));
      formData.append("foldername", foldername.trim());

      const response = (await postFormDataAPI(
        "/v1/images/multiple",
        formData,
      )) as SwayyAPIResponse<unknown>;

      const payload = response.data ?? response.result;
      const urls = extractUrls(payload);

      if (!response.success || urls.length === 0) {
        throw new Error(response.message || "Failed to upload images");
      }

      return urls;
    } catch (error) {
      throw error;
    }
  };
}
